export const ProductRecommendations = "6928283f85b03b7b772e6e796fbf9cd228caac7df9d30ca8a360e1a873370bf4";